import * as React from "react";
import { ReservationForm } from "../modules/Main";
import useSpectacle from "../modules/Main/hooks/useSpectacle";
import SpectacleInformations from "../modules/Main/components/SpectacleInformations";
import { Redirect } from "react-router";
import SpectacleFullScreen from "./SpectacleFullScreen";
import SpectacleBOW from "./SpectacleBOW";
import SplashLoadingScreen from "./SplashLoadingScreen";
import SplashErrorScreen from "./SlashErrorScreen";
import SplashNotInternet from "./SplashNotInternet";
import { Context } from '../modules/Main/components/Context'

const HomeScreen: React.FC<any> = props => {
  const spectacleId = Number.parseInt(props.match.params.sid, 10);

  const { xMax, yMax, xMin, yMin, state } = useSpectacle(spectacleId);
  const [full, setFull] = React.useState(false);
  const [context, setContext] = React.useState('');

  React.useEffect(() => {
    if (state.data && !state.isLoading) {
      if (state.data.seats) {
        setFull(!state.data.seats.map(seat => seat.reserved).includes(false));
      }
    }
  }, [state]);

  if (state.isLoading || !state.data || !xMax || !xMin || !yMax || !yMin) {
    return <SplashLoadingScreen />;
  }

  if (!spectacleId || state.error) {
    return <SplashErrorScreen />;
  }

  if(state.data.spectacle.BOW) {
    return <SpectacleBOW />;
  }

  if (full) {
    return <SpectacleFullScreen />;
  }

  if (Object.keys(state.data.areaPrices).length === 0) {
    return <SplashNotInternet />;
  }

  return (
    <Context.Provider value={[context, setContext]}>
      <SpectacleInformations data={state.data.spectacle} />
      <ReservationForm
        spectacleId={spectacleId}
        xMax={xMax}
        xMin={xMin}
        yMax={yMax}
        yMin={yMin}
        {...state.data}
      />
      <div className="footer">
        <img src="/images/karty.jpg" alt="" />
        <img src="/images/dotpay.jpg" alt="" />
      </div>
      </Context.Provider>
  );
};

export default HomeScreen;
